"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVFormImportControl = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var input_select_1 = require("../../components/input/input.select");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var trigger_1 = require("../../services/util/trigger");
var store_1 = require("../../store");
exports.CSS = {
    container: 'c-ImportMapper',
    spinner: 'c-ImportMapper__spinner',
    header: 'c-ImportMapper__header',
    body: 'c-ImportMapper__body',
    isInvalid: 'c-ImportMapper--invalid'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.spinner] = {
        margin: 'auto',
        padding: theme_1.DefaultTheme.space(2),
        display: 'flex',
        'justify-content': 'center'
    },
    _a[exports.CSS.container] = {
        padding: '8px',
        width: '100%',
        'table-layout': 'fixed',
        'font-family': theme_1.DefaultTheme.font.familyCondensed
    },
    _a[exports.CSS.body + ' td'] = {
        padding: theme_1.DefaultTheme.space(1),
        'max-width': 0,
        overflow: 'hidden',
        'min-width': 0,
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.isInvalid] = {
        color: 'red'
    },
    _a));
var CSVFormImportControl = /** @class */ (function (_super) {
    tslib_1.__extends(CSVFormImportControl, _super);
    function CSVFormImportControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trigger = new trigger_1.IkeTrigger('CSVImport');
        _this.data = null;
        _this.form = null;
        _this.mappings = [];
        _this.isLoading = false;
        _this.isValid = false;
        return _this;
    }
    CSVFormImportControl.prototype.setLoaded = function () {
        this.isValid = this.mapper.isValid;
        this.isLoading = false;
    };
    Object.defineProperty(CSVFormImportControl.prototype, "collections", {
        get: function () {
            return (this.mapper != null && this.mapper.processed) || [];
        },
        enumerable: false,
        configurable: true
    });
    CSVFormImportControl.prototype.process = function (formId, data) {
        if (!data.isValid) {
            throw new Error('Invalid CSV given');
        }
        this.isLoading = true;
        this.formId = formId;
        this.data = data;
        this.loadFormAndProcess();
    };
    CSVFormImportControl.prototype.loadFormAndProcess = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var form, _loop_1, this_1, _i, _a, mapping;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, store_1.AppStore.Form.fetch(this.formId)];
                    case 1:
                        form = _b.sent();
                        this.form = form;
                        this.mapper = new core_shared_1.IkeCSVMapper(this.data, form);
                        this.mapper.setDefaultMappings();
                        this.mappings = [];
                        _loop_1 = function (mapping) {
                            var displayName = mapping.fieldKey ? mapping.field.displayName + ' ' + (0, i18n_1.Translate)(mapping.fieldKey.toUpperCase()) : mapping.field.displayName;
                            var selection = new input_select_1.SelectInputState(displayName);
                            this_1.reaction(function () { return selection.value; }, function (headerKey) { return _this.setMapping(mapping, headerKey); });
                            for (var _c = 0, _d = this_1.data.headers; _c < _d.length; _c++) {
                                var header = _d[_c];
                                selection.addOption({ key: header, value: header });
                            }
                            selection._value = this_1.data.headers[mapping.csvIndex] || null;
                            this_1.mappings.push({ mapping: mapping, selection: selection });
                        };
                        this_1 = this;
                        for (_i = 0, _a = this.mapper.mappings; _i < _a.length; _i++) {
                            mapping = _a[_i];
                            _loop_1(mapping);
                        }
                        this.setLoaded();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CSVFormImportControl.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.isLoading || this.form == null) {
                return (0, mithril_1.m)('div', { className: exports.CSS.spinner }, spinner_1.Spinner.view());
            }
            this.trigger.observe();
            return (0, mithril_1.m)('table', { className: exports.CSS.container }, [
                (0, mithril_1.m)('thead', { className: exports.CSS.header }, this.mappings.map(function (h) { return (0, mithril_1.m)('th', input_select_1.SelectInputComponent.view(h.selection)); })),
                (0, mithril_1.m)('tbody', { className: exports.CSS.body }, this.collections.map(function (r, i) { return _this.viewRow(i); }))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CSVFormImportControl.prototype.viewRow = function (index) {
        var children = [];
        var hasValue = false;
        for (var _i = 0, _a = this.mappings; _i < _a.length; _i++) {
            var mapping = _a[_i];
            if (mapping == null || mapping.selection.value == null) {
                children.push((0, mithril_1.m)('td'));
            }
            else {
                hasValue = true;
                var mappedValue = this.mapper.getCollectionValue(mapping.mapping, index);
                if (mappedValue.isValid) {
                    children.push((0, mithril_1.m)('td', mappedValue.value));
                }
                else {
                    this.isValid = false;
                    children.push((0, mithril_1.m)('td', { className: exports.CSS.isInvalid, title: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_FIELD_INVALID, { field: mapping.mapping.field.displayName }) }, mappedValue.raw));
                }
            }
        }
        if (hasValue) {
            return (0, mithril_1.m)('tr', {}, children);
        }
        return null;
    };
    CSVFormImportControl.prototype.setMapping = function (mapping, csvHeader) {
        var headerIndex = this.data.getHeaderIndex(csvHeader);
        this.mapper.setMapping(mapping, headerIndex);
        this.isValid = this.mapper.isValid;
        // Force a redraw
        this.trigger.trigger();
    };
    CSVFormImportControl.prototype.reset = function () {
        this.formId = null;
        this.data = null;
        this.isLoading = true;
        this.isValid = false;
        this.mappings = [];
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFormImportControl.prototype, "formId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFormImportControl.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFormImportControl.prototype, "isValid", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFormImportControl.prototype, "setLoaded", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFormImportControl.prototype, "process", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFormImportControl.prototype, "setMapping", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFormImportControl.prototype, "reset", null);
    return CSVFormImportControl;
}(mithril_component_1.IMithrilStateComponent));
exports.CSVFormImportControl = CSVFormImportControl;
//# sourceMappingURL=import.ctrl.js.map